import React, { useState, useEffect } from "react";
import CustomLoader from "../../../common/Loader";
import {Checkbox} from "@mui/material";

function CheckboxViewer({Question_ID, Question_Number, OnUpdate, preloadQAData, Response_Required, SurveyMode, disabled}) {
    const [loading, setLoading] = useState(true);
    const [checked, setChecked] = useState(false);


    useEffect(() => {
        setChecked(preloadQAData ? preloadQAData.Answer_Text === "true": false);
        setLoading(false);
    }, []);

    const handleSelection = () => {
        if (SurveyMode) {
            OnUpdate(Question_Number, {
                Responses: [
                    {
                        Question_Number: Question_Number,
                        Question_ID: Question_ID,
                        Answer_ID: null,
                        Answer_Text: !checked,
                    },
                ],
                Response_Required: Response_Required, // TODO check why this is needed here
            });
            setChecked(!checked);
        }
    };

    if (loading) {
        return <CustomLoader loading={loading} />;
    }

    return (
        <Checkbox
            name={"Q" + Question_ID}
            className='ml-3'
            key={"Q" + Question_ID}
            checked={checked}
            onChange={handleSelection}
            disabled={disabled}
        />
    );
};

export default CheckboxViewer;
